export default __webpack_public_path__ + "/dist/images/restaurent-icon.48fd26628c166b92c150d8133f3fcb5c.svg";